module.exports = __webpack_public_path__ + "static/img/21.9409c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/21.png
// module id = 0ghx
// module chunks = 0